import React from "react";
import Image from "next/image";
import IMAGES from "@/public/assets/img";

const SavingsAndProcess = ({ savingsData, processData, onApplyNow }) => {
  if (!savingsData || !processData) return null;
  return (
    <section className="bg-white py-sp-100 sm:py-20">
      <div className="container px-3">

        <div className="mb-20 sm:mb-12">
          <h2
            className="text-darkBlack text-heading2 sm:text-2xl font-medium mb-3 text-center"
            dangerouslySetInnerHTML={{ __html: savingsData.heading }}
          />
          <p className="text-darkBlack text-lg sm:text-base text-center">
            {savingsData.subHeading}
          </p>

          <div className="flex sm:flex-col gap-4 max-w-[850px] mx-auto justify-between items-stretch mt-6">
            <div className="flex-1 bg-white p-8 sm:p-3 rounded-2xl border border-borderColor flex flex-col justify-between">
              <div>
                <span className="block text-sm text-[#072F5F] mb-4">
                  {savingsData.withoutSubvention.title}
                </span>
                <span className="block text-3xl font-semibold text-[#072F5F] mb-4">
                  {savingsData.withoutSubvention.value}
                </span>
                <p className="text-[#072F5F] text-sm">
                  {savingsData.withoutSubvention.description}
                </p>
              </div>
            </div>

            <div className="flex-1 bg-[#FFFAED] p-8 sm:p-3 rounded-2xl border border-[#E3A003] flex flex-col justify-between">
              <div>
                <span className="block text-sm text-[#072F5F] mb-4">
                  {savingsData.withSubvention.title}
                </span>
                <span className="block text-3xl font-semibold text-[#072F5F] mb-4">
                  {savingsData.withSubvention.value}
                </span>
                <p className="text-[#072F5F] text-sm">
                  {savingsData.withSubvention.description}
                </p>
              </div>
              <button
                onClick={onApplyNow}
                className="text-sm mt-4 w-full bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-lg transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C] text-white font-medium py-2 px-4 rounded-md"
              >
                {savingsData.withSubvention.buttonText}
              </button>
            </div>
          </div>
        </div>

        <div>
          <h2 className="text-darkBlack text-heading2 sm:text-2xl font-medium mb-2 text-center">
            {processData.heading}
          </h2>
          <p className="text-darkBlack text-lg sm:text-base text-center mb-16 sm:mb-6">
            {processData.subHeading}
          </p>

          <div className="sm:hidden w-full max-w-[1050px] h-[600px] mx-auto relative flex items-center justify-center">
            <div className="absolute inset-0 w-full h-full z-10">
              <Image
                src={IMAGES.exportInterest.stepBG}
                alt="Process Stroke"
                fill
                className="object-contain"
              />
            </div>
            <div className="relative z-20">
              <Image
                src={IMAGES.exportInterest.processCenterpiece}
                alt="Process Centerpiece"
                width={400}
                height={277}
                className="object-contain"
              />
            </div>
          </div>

          <div className="hidden sm:block mt-8">
            <div className="relative mx-auto mb-8">
              <Image
                src={IMAGES.exportInterest.processCenterpiece}
                alt="Process Centerpiece"
                width={400}
                height={277}
                className="object-contain"
              />
            </div>

            <div className="flex flex-col gap-6 px-4 sm:px-1">
              {processData.steps.map((step, index) => (
                <div key={step.id} className="flex gap-4 relative">
                  <div className="flex flex-col items-center">
                    <div className="w-8 h-8 rounded-full bg-[#022B5C] text-white flex items-center justify-center font-bold text-sm shrink-0 z-10">
                      {step.id}
                    </div>
                    {index < processData.steps.length - 1 && (
                      <div className="w-[2px] bg-[#022B5C]/20 grow my-2" />
                    )}
                  </div>
                  <div className="pb-4">
                    <h4 className="text-[#1C1C1C] font-medium text-base2 mb-xsp">{step.title}</h4>
                    <p className="text-gray text-sm leading-relaxed">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default SavingsAndProcess;
